<template>
  <div>
    <!--提示语-->
    <div style="padding: 10px;color: #d9d9d9">{{ $t('CargoMsg.Cargo_OcrTip') }}</div>
    <div class="result-form-se">
      <div :style="{cursor:'pointer',width: showBookRecognitionResults ? '70%': '50%'}">
        <!--ocr识别字段-header-->
        <div class="header-container">
          <div v-if="showBookRecognitionResults" class="column-header recognition-header">
            <span>{{ $t('CargoMsg.Cargo_BookRecognitionResults') }}</span>
            <span class="toggle-btn" @click="showBookRecognitionResults=false">{{ $t('CargoMsg.Cargo_PackUp') }}</span>
          </div>
          <div class="column-header confirmed-header">
            <span>{{ $t('CargoMsg.Cargo_ConfirmedBusinessData') }}</span>
            <span v-if="!showBookRecognitionResults" class="toggle-btn" @click="showBookRecognitionResults=true">{{ $t('CargoMsg.Cargo_ExpandAll') }}</span>
          </div>
        </div>
        <!--ocr识别字段-content-->
        <div v-if="currentOcrRecognitionFields && currentOcrRecognitionFields.length > 0">
          <div v-for="item in currentOcrRecognitionFields" :key="item.code">
            <!--委托单位-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMER_ID.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ConsignationCompany') }}</div>

              <!--委托单位 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ConsignationCompany') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.ConsignationCompany') }}</div>
                <div class="field-value">
                  <cargo-company-select
                    :method-params="{customer:true,companyLob:'seaExport',active:true}"
                    :default-value="job.customerId||''"
                    :placeholder="!job.customerId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.customerId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @change="p=>{customerIdChangeHandlerOcr(p)}"
                  />
                </div>
              </div>
            </div>
            <!--进仓编号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_WAREHOUSE_NO.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.WarehouseNo') }}</div>

              <!--进仓编号 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.WarehouseNo') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.WarehouseNo') }}</div>
                <div class="field-value">
                  <el-input v-model="job.warehouseNo" />
                </div>
              </div>
            </div>
            <!--发货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SHIPPER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Shipper') }}</div>

              <!--发货人 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Message.Shipper') }}</div>
                <div class="field-value field-value-textarea">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Message.Shipper') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.shipper" :rows="6" type="textarea" />
                </div>
              </div>
            </div>
            <!--收货人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONSIGNEE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Consignee') }}</div>

              <!--收货人 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Message.Consignee') }}</div>
                <div class="field-value field-value-textarea">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Message.Consignee') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.consignee" :rows="6" type="textarea" />
                </div>
              </div>
            </div>
            <!--通知人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_NOTIFY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Message.Notify') }}</div>

              <!--通知人 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Message.Notify') }}</div>
                <div class="field-value field-value-textarea">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Message.Notify') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.notify" :rows="6" type="textarea" />
                </div>
              </div>
            </div>
            <!--船公司-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARRIER.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ShippingCompany') }}</div>

              <!--船公司 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ShippingCompany') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.ShippingCompany') }}</div>
                <div class="field-value">
                  <cargo-company-select
                    :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                    :default-value="job.carrierId||''"
                    :placeholder="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.carrierId && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @change="p=>{pm.carrierChangeHandler(job.dischargingPortCode, p.value);initIfAutoBookingHandle(job);cargoEnglishNameCheckSensitiveWord(job)} "
                  />
                </div>
              </div>
            </div>
            <!--船名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VESSEL.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.vessel') }}</div>

              <!--船名 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.vessel') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Payment.vessel') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="vessel"
                    :select-type="selectTypeNames.static_data_Vessel"
                    :cache="false"
                    filterable
                    :allow-create="true"
                    :default-value="job.vessel"
                    :static-options="vesselList"
                    @parentCallBack="p=>{onVesselSelectionChange(p)}"
                  />
                </div>
              </div>
            </div>
            <!--航次-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VOYAGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.voyage') }}</div>

              <!--航次 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.voyage') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Payment.voyage') }}</div>
                <div class="field-value" style="display: flex;justify-content: space-between">
                  <el-input v-model="job.voyageFlight" />
                  <el-button v-if="showChooseShippingSchedulesBtn" type="primary" style="background-color: #169bd5; margin-left: 8px;" @click="btnVayageShowHandle">{{ $t('CargoMsg.Cargo_ChooseShippingSchedules') }}</el-button>
                </div>
              </div>
            </div>
            <!--开航日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ETD.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dateOfDeparture') }}</div>

              <!--开航日期 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dateOfDeparture') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('queryJob.dateOfDeparture') }}</div>
                <div class="field-value">
                  <el-date-picker
                    :value="job.etd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @input="etdChange"
                  />
                </div>
              </div>
            </div>
            <!--运费条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PAYMENT_TERM.code" class="row" @click="handleFocus(item.code)">
              <div style="display: block; width:100%">
                <div style="display: flex">
                  <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.FreightTerm') }}</div>

                  <!--运费条款 识别结果-->
                  <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                    <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.FreightTerm') }}</div>
                    <div class="field-value">{{ resultJson[item.code] }}</div>
                  </div>

                  <div class="item3">
                    <div class="field-label">{{ $t('SeaExport.FreightTerm') }}</div>
                    <div class="field-value">
                      <cargo-advance-select
                        :select-type="selectTypeNames.basic_data_PaymentTerm"
                        filterable
                        clearable
                        :default-value="job.paymentTermMBL"
                        :placeholder="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                        :class="!job.paymentTermMBL && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                        @clear="clear(item)"
                        @parentCallBack="p=>{
                          paymentTermMBL = p.value;
                          job.paymentTermMBL=p.value;
                        }"
                      />
                    </div>
                  </div>
                </div>
                <!--付款方-->
                <div v-show="paymentTermMBL === '3P'" style="display: flex">
                  <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_Payment1') }}</div>

                  <!--付款方 识别结果-->
                  <div v-if="showBookRecognitionResults" class="item2">
                    <div class="field-label">{{ $t('CargoMsg.Cargo_Payment1') }}</div>
                    <div class="field-value field-value-textarea" />
                  </div>

                  <div class="item3">
                    <div class="field-label">{{ $t('CargoMsg.Cargo_Payment1') }}</div>
                    <div class="field-value field-value-textarea">
                      <el-input v-model="job.paymentData" :rows="6" type="textarea" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--箱型箱量-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_INFOS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CartonQuantity') }}</div>

              <!--箱型箱量 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CartonQuantity') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3" style="overflow-y: auto;">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CartonQuantity') }}</div>
                <div class="field-value">
                  <div style="display: flex; flex-direction: column;">
                    <div style="display: flex; flex-direction: column; max-height: 200px;">
                      <div v-for="(eqItem,index) in job.seaEQ" :key="index">
                        <div style="display: flex; align-items: center; margin-bottom: 8px;">
                          <el-input-number
                            v-model="eqItem.eqQuantity"
                            :controls="false"
                            class="item3-1"
                            no="eqQuantity"
                            style="width: 80px; margin-right: 5px;"
                          />
                          <span style="margin-right: 5px;">X</span>
                          <cargo-advance-select
                            class="item3-1"
                            no="eqSize"
                            :select-type="selectTypeNames.local_cache_EQSize"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :default-value="eqItem.eqSize"
                            style="width: 80px; margin-right: 5px;"
                            tag-name="code"
                            @parentCallBack="p=>{changeSizeCallBack(eqItem, p)}"
                          />
                          <cargo-advance-select
                            class="item3-1"
                            no="eqType"
                            :select-type="selectTypeNames.basic_data_EQType"
                            :fields="['code']"
                            filterable
                            :placeholder="' '"
                            :show-copy="false"
                            :default-value="eqItem.eqType"
                            style="width: 80px; margin-right: 10px;"
                            tag-name="code"
                            @parentCallBack="p=>{changeTypeCallBack(eqItem, p)}"
                          />
                          <div style="color: #1398f1; margin-right: 5px; font-size: 18px; cursor: pointer; user-select: none;" @click="addSeaEQ">+</div>
                          <div style="color: #1398f1; font-size: 18px; cursor: pointer; user-select: none;" @click="deleteSeaEQ(index)">-</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!job.seaEQ || job.seaEQ.length === 0" style="color: #1398f1; margin-top: 10px; cursor: pointer;" @click="addSeaEQ">{{ $t('CargoMsg.Cargo_Add') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!--贸易条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INCO_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.IncoTerm') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.IncoTerm') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>
              <div class="item3">
                <div class="field-label">{{ $t('queryJob.IncoTerm') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="incoTerm"
                    :select-type="selectTypeNames.basic_data_IncoTerm"
                    filterable
                    clearable
                    :default-value="job.incoTerm"
                    :placeholder="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.incoTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{job.incoTerm=p.value;customerRefNoCheckSensitiveWord(job)}"
                  />
                </div>
              </div>
            </div>
            <!--联系人-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMER_CONTACT.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.contactPerson') }}</div>

              <!--联系人 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.contactPerson') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Payment.contactPerson') }}</div>
                <div class="field-value">
                  <el-input v-model="job.customerContact" />
                </div>
              </div>
            </div>
            <!--货物尺寸-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_MEASUREMENTS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CargoSize') }}</div>

              <!--货物尺寸 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CargoSize') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.CargoSize') }}</div>
                <div class="field-value">
                  <el-input v-model="job.measurements" />
                </div>
              </div>
            </div>
            <!--起运港-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.portOfLoading') }}</div>

              <!--起运港 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.portOfLoading') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Payment.portOfLoading') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="englishName"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :default-value="job.loadingPortCode"
                    tag-name="englishName"
                    :placeholder="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.loadingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.setPlannerChange();cargoEnglishNameCheckSensitiveWord(job)}"
                  />
                </div>
              </div>
            </div>
            <!--中转港-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_TRANSFER_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.portOfTransfer') }}</div>

              <!--中转港 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.portOfTransfer') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('Payment.portOfTransfer') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="transferPortCode"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :default-value="job.transferPortCode"
                    :placeholder="!job.transferPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.transferPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{job.transferPortCode=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--卸货港-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dischargingPortCode') }}</div>

              <!--卸货港 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.dischargingPortCode') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('queryJob.dischargingPortCode') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="dischargingPortCode"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :default-value="job.dischargingPortCode"
                    :placeholder="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.dischargingPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{pm.dischargingPortCodeChange(p.value,job.carrierId);cargoEnglishNameCheckSensitiveWord(job)}"
                  />
                </div>
              </div>
            </div>
            <!--交货地-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DESTINATION_PORT_CODE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.placeOfDelivery') }}</div>

              <!--交货地 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.placeOfDelivery') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('queryJob.placeOfDelivery') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="destinationPortCode"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :default-value="job.destinationPortCode"
                    :placeholder="!job.destinationPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.destinationPortCode && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{job.destinationPortCode=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--件数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_QUANTITY.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Quantity') }}</div>

              <!--件数 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Quantity') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.Quantity') }}</div>
                <div class="field-value">
                  <el-input-number v-model="job.quantityContract" :controls="false" no="quantityContract" style="text-align: left; width: 100%;" />
                </div>
              </div>
            </div>
            <!--包装-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PACKING.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Package') }}</div>

              <!--包装 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Package') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.Package') }}</div>
                <div class="field-value">
                  <cargo-packing-select
                    no="packing"
                    :default-value="job.packing"
                    :placeholder="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.packing && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @change="p=>{job.packing=p.value;}"
                  />
                </div>
              </div>
            </div>
            <!--体积-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUBAGE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Cubage') }}</div>

              <!--体积 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Cubage') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.Cubage') }}</div>
                <div class="field-value">
                  <el-input-number v-model="job.cubageContract" :precision="3" :controls="false" no="cubageContract" style="text-align: left; width: 100%;" />
                </div>
              </div>
            </div>
            <!--毛重-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_GROSS_WEIGHT.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Weight') }}</div>

              <!--毛重 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Weight') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.Weight') }}</div>
                <div class="field-value">
                  <el-input-number v-model="job.weightContract" :precision="3" :controls="false" no="weightContract" style="text-align: left; width: 100%;" />
                </div>
              </div>
            </div>
            <!--唛头-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_MARK.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Marks') }}</div>

              <!--唛头 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Marks') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="resultJson[item.code]" disabled :rows="6" type="textarea" />
                </div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.Marks') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.mark" :rows="6" type="textarea" no="mark" />
                </div>
              </div>
            </div>
            <!--品名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_GOOD_NAME.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Pricing.Goods') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Pricing.Goods') }}</div>
                <div class="field-value field-value-textarea">{{ resultJson[item.code] }}</div>
              </div>
              <div class="item3">
                <div class="field-label">{{ $t('Pricing.Goods') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.cargoEnglishName" :rows="6" type="textarea" :class="job.ifContainSensitiveWord===true ? 'color-yellow' : ''" no="cargoEnglishName" @change="cargoEnglishNameCheckSensitiveWord(job)" />
                </div>
              </div>
            </div>
            <!--备注-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_REMARKS.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('Payment.remarks') }}</div>
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('Payment.remarks') }}</div>
                <div class="field-value field-value-textarea">{{ resultJson[item.code] }}</div>
              </div>
              <div class="item3">
                <div class="field-label">{{ $t('Payment.remarks') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input v-model="job.remarks" :rows="5" type="textarea" />
                </div>
              </div>
            </div>
            <!--提单形式-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ORDER_TYPE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BLForm') }}</div>

              <!--提单形式 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BLForm') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.BLForm') }}</div>
                <div class="field-value">
                  <el-select
                    v-model="job.orderType"
                    :placeholder="!job.orderType && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.orderType && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    no="orderType"
                    clearable
                    @clear="clear(item)"
                  >
                    <el-option
                      v-for="(item,index) in blModeList"
                      :key="index"
                      :label="item.name"
                      :value="item.serialNumber"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <!--整箱拼箱-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONTAINER_LOAD_TYPE.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.LCL') }}</div>

              <!--整箱拼箱 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.LCL') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.LCL') }}</div>
                <div class="field-value">
                  <el-select v-model="job.containerLoadType" no="containerLoadType" @change="initIfAutoBookingHandle(job)">
                    <el-option
                      v-for="(item,index) in (containerLoadTypes)"
                      :key="index"
                      :label="isZh?item.chineseName:item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <!--运输条款-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_FREIGHT_TERM.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.TransportationClause') }}</div>

              <!--运输条款 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.TransportationClause') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('SeaExport.TransportationClause') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="freightTerm"
                    :select-type="selectTypeNames.basic_data_ShippingTerm"
                    filterable
                    clearable
                    :default-value="job.freightTerm"
                    :placeholder="!job.freightTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? resultJson[item.code] : ''"
                    :class="!job.freightTerm && resultJson[item.code] && !resultJson[item.code + '_notShowPlaceholder'] ? 'color-red' : ''"
                    @clear="clear(item)"
                    @parentCallBack="p=>{job.freightTerm=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--业务参考号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMER_REF_NO.code" class="row" @click="handleFocus(item.code)">
              <div class="item1">{{ $t('CargoMsg.Cargo_BusinessReferenceNo') }}</div>

              <!--业务参考号 识别结果-->
              <div v-if="showBookRecognitionResults" class="item2" :class="{ 'field-red-border': item.redColor }" @click="handleFocus(item.code)">
                <div class="field-label">{{ $t('CargoMsg.Cargo_BusinessReferenceNo') }}</div>
                <div class="field-value">{{ resultJson[item.code] }}</div>
              </div>

              <div class="item3">
                <div class="field-label">{{ $t('CargoMsg.Cargo_BusinessReferenceNo') }}</div>
                <div class="field-value">
                  <el-input v-model="job.customerRefNo" @change="customerRefNoCheckSensitiveWord(job)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :style="{marginLeft:'5px',width: showBookRecognitionResults ? '30%': '50%'}">
        <!--额外补录字段-header-->
        <div class="column-header other-data-header">
          <span>{{ $t('CargoMsg.Cargo_OtherData') }}</span>
        </div>
        <!--额外补录字段-content-->
        <div v-if="currentOcrOtherFields && currentOcrOtherFields.length > 0">
          <div v-for="item in currentOcrOtherFields" :key="item.code">
            <!--揽货类型-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARGOSOURCE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_SolicitationType') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_SolicitationType') }}</div>
                <div class="field-value">
                  <el-select
                    v-model="job.cargoSource"
                    no="cargoSource"
                    :placeholder="$t('SeaExport.PleaseSelect')"
                    size="mini"
                  >
                    <el-option
                      v-for="(item,index) in SystemConstants.CARGO_SOURCES"
                      :key="index"
                      :label="isZh?item.chineseName:item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <!--预计到货日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_ARRIVEDATE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CargosExpectedArrivalDate') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CargosExpectedArrivalDate') }}</div>
                <div class="field-value">
                  <el-date-picker
                    v-model="job.arriveDate"
                    no="arriveDate"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
              </div>
            </div>
            <!--截关日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMCUTOFF.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CYCutOffDate') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CYCutOffDate') }}</div>
                <div class="field-value">
                  <el-date-picker
                    v-model="job.customCutoff"
                    no="customCutoff"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
              </div>
            </div>
            <!--客户截关日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMERCUTOFF.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CustomerCyCutOffDate') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CustomerCyCutOffDate') }}</div>
                <div class="field-value">
                  <el-date-picker
                    v-model="job.customerCutoff"
                    no="customerCutoff"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
              </div>
            </div>
            <!--客户退关日期-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMERSHUTOUT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CustomerShutOutDate') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CustomerShutOutDate') }}</div>
                <div class="field-value">
                  <el-date-picker
                    v-model="job.customerShutout"
                    no="customerShutout"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
              </div>
            </div>
            <!--客户截单时间-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMERFILECUTOFF.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CustomerClosingTime') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CustomerClosingTime') }}</div>
                <div class="field-value">
                  <el-date-picker
                    v-model="job.customerFileCutoff"
                    no="customerFileCutoff"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
              </div>
            </div>
            <!--客服-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CSR.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomerService') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomerService') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="csr"
                    no="csr"
                    :method-params="{officeId:job.salesOffice===1?job.opOffice:job.salesOffice, category:'role',shape:'csr'}"
                    :default-value="job.csr||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.csr : []) : []"
                    @change="p=>{csrChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--单证-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DC.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_Documents') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_Documents') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="dc"
                    no="dc"
                    :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
                    :default-value="job.dc||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.doc : []) : []"
                    @change="p=>{dcChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--约号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SC_NO.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ContractNo') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.ContractNo') }}</div>
                <div class="field-value">
                  <el-input v-model="job.scNo" />
                </div>
              </div>
            </div>
            <!--小件数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INSIDEQUANTITY.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_InsideQuantity') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_InsideQuantity') }}</div>
                <div class="field-value">
                  <auto-number-input
                    v-model="job.insideQuantity"
                    no="insideQuantity"
                    :precision="0"
                    :min="0"
                    @valCallBack="(val)=>{
                      job.insideQuantity = val
                    }"
                  />
                </div>
              </div>
            </div>
            <!--小件包装-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_INSIDEPACKING.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_InsidePacking') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_InsidePacking') }}</div>
                <div class="field-value">
                  <cargo-packing-select
                    no="insidePacking"
                    :default-value="job.insidePacking"
                    @change="p=>{job.insidePacking=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--计费重量RT-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CHARGEWEIGHT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ChargedWeightRT') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.ChargedWeightRT') }}</div>
                <div class="field-value">
                  <auto-number-input
                    v-model="job.chargeWeight"
                    no="chargeWeight"
                    :precision="3"
                    :min="0"
                    @valCallBack="(val)=>{
                      job.chargeWeight = val
                    }"
                  />
                  <span style="display: flex;align-items: center">M/T</span>
                </div>
              </div>
            </div>
            <!--中文品名-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARGOCHINESENAME.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_ChineseCargoName') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_ChineseCargoName') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input
                    v-model="job.cargoChineseName"
                    no="cargoChineseName"
                    type="textarea"
                    :autosize="{ maxRows:5, minRows:2 }"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
                  />
                </div>
              </div>
            </div>
            <!--自定义字段1-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_USERDEFINEDFIELD1.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomizedField1') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomizedField1') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input
                    v-model="job.userDefinedField1"
                    no="userDefinedField1"
                    type="textarea"
                    :autosize="{ maxRows:5, minRows:2 }"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
                  />
                </div>
              </div>
            </div>
            <!--自定义字段2-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_USERDEFINEDFIELD2.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomizedField2') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomizedField2') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input
                    v-model="job.userDefinedField2"
                    no="userDefinedField2"
                    type="textarea"
                    :autosize="{ maxRows:5, minRows:2 }"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
                  />
                </div>
              </div>
            </div>
            <!--自定义字段3-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_USERDEFINEDFIELD3.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomizedField3') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomizedField3') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input
                    v-model="job.userDefinedField3"
                    no="userDefinedField3"
                    type="textarea"
                    :autosize="{ maxRows:5, minRows:2 }"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
                  />
                </div>
              </div>
            </div>
            <!--自定义字段4-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_USERDEFINEDFIELD4.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomizedField4') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomizedField4') }}</div>
                <div class="field-value field-value-textarea">
                  <el-input
                    v-model="job.userDefinedField4"
                    no="userDefinedField4"
                    type="textarea"
                    :autosize="{ maxRows:5, minRows:2 }"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
                  />
                </div>
              </div>
            </div>
            <!--销售-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SALES.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Sales') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.Sales') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="sales"
                    no="sales"
                    :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                    :default-value="job.sales||''"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).salesList && jobViewInfoMap.get(job.index).salesList.length > 0 ? jobViewInfoMap.get(job.index).salesList : []) : []"
                    :merge-load="true"
                    @change="p=>{job.sales=p.value;salesChangeHandler(p, job)}"
                  />
                </div>
              </div>
            </div>
            <!--销售公司-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SALES_OFFICE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.SalesCompany') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.SalesCompany') }}</div>
                <div class="field-value">
                  <cargo-office-select
                    no="salesOffice"
                    :office-id="Number(job.salesOffice)"
                    @change="p=>{job.salesOffice=p.value||0;}"
                  />
                </div>
              </div>
            </div>
            <!--销售部门-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SALES_DEPARTMENT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.SalesDepartment') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.SalesDepartment') }}</div>
                <div class="field-value">
                  <cargo-department-select
                    no="salesDepartment"
                    :sales-id="Number(job.sales)"
                    :office-id="job.salesOffice"
                    :enables="true"
                    :department-id="Number(job.salesDepartment)"
                    @change="p=>{job.salesDepartment=p.value;}"
                  />
                </div>
              </div>
            </div>
            <!--操作-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_OP.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.Operation') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.Operation') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="op"
                    no="op"
                    :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
                    :default-value="job.op||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.op : []) : []"
                    @change="p=>{job.op=p.value;txtOPChangeHandler(p, job)}"
                  />
                </div>
              </div>
            </div>
            <!--操作公司-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_OP_OFFICE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.OperationCompany') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.OperationCompany') }}</div>
                <div class="field-value">
                  <cargo-office-select
                    no="opOffice"
                    :disabled="true"
                    :office-id="Number(job.opOffice)"
                  />
                </div>
              </div>
            </div>
            <!--操作部门-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_OP_DEPARTMENT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.OperationDepartment') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.OperationDepartment') }}</div>
                <div class="field-value">
                  <cargo-department-select
                    no="opDepartment"
                    :office-id="Number(job.opOffice)"
                    :enables="true"
                    :department-id="Number(job.opDepartment)"
                    @change="p=>{job.opDepartment=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--货物类型-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARGO_TYPE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CargoType') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CargoType') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="cargoType"
                    :select-type="selectTypeNames.basic_data_CargoType"
                    :method-params="{sea:true}"
                    filterable
                    clearable
                    :default-value="job.cargoType"
                    @parentCallBack="p => { job.cargoType = p.value;cargoTypeHandle()}"
                  />
                </div>
              </div>
            </div>
            <!--订舱代理-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_BOOKING_AGENT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BookingAgent') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.BookingAgent') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="bookingAgent"
                    :select-type="selectTypeNames.basic_data_Company"
                    filterable
                    :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
                    :default-value="job.bookingAgent||''"
                    @parentCallBack="p=>{job.bookingAgent = p.value;initIfAutoBookingHandle(job)}"
                  />
                </div>
              </div>
            </div>
            <!--船舶呼号-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_VESSEL_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BookingShipCallSign') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.BookingShipCallSign') }}</div>
                <div class="field-value">
                  <el-input v-model="job.vesselCode" />
                </div>
              </div>
            </div>
            <!--是否自动订舱-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_IF_AUTO_BOOKING.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_IfAutoBooking') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_IfAutoBooking') }}</div>
                <div class="field-value">
                  <el-select v-model="job.ifAutoBooking" :disabled="job.ifAutoBookingDisabled">
                    <el-option v-for="(item, index) in IF_AUTO_BOOKING" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                  </el-select>
                </div>
              </div>
            </div>
            <!--NOVCC-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_NOVCC.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ 'NOVCC' }}</div>
              <div class="item4">
                <div class="field-label">{{ 'NOVCC' }}</div>
                <div class="field-value">
                  <el-input v-model="job.novcc" no="novcc" />
                </div>
              </div>
            </div>
            <!--TLI NO-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_TLI_NO.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ 'TLI NO' }}</div>
              <div class="item4">
                <div class="field-label">{{ 'TLI NO' }}</div>
                <div class="field-value">
                  <el-input v-model="job.tliNo" no="tliNo" />
                </div>
              </div>
            </div>
            <!--货值-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARGO_AMOUNT.code" class="row" @click="handleFocus(item.code)">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CargoAmount') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CargoAmount') }}</div>
                <div class="field-value">
                  <el-input-number v-model="job.amount" :controls="false" no="amount" style="text-align: left; width: 100%;" />
                </div>
              </div>
            </div>
            <!--货币-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CARGO_CURRENCY.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CargoCurrency') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CargoCurrency') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="currency"
                    :select-type="selectTypeNames.basic_data_Currency"
                    filterable
                    :default-value="job.currency||''"
                    @parentCallBack="p=>{job.currency = p.value}"
                  />
                </div>
              </div>
            </div>
            <!--客户预定航次-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CUSTOMER_RESERVE_VOYAGE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_CustomerReserveVoyage') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_CustomerReserveVoyage') }}</div>
                <div class="field-value">
                  <el-input v-model="job.customerReserveVoyage" />
                </div>
              </div>
            </div>
            <!--生成业务份数-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_PAGE_NUM.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_GenerateNumberOfBusiness') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_GenerateNumberOfBusiness') }}</div>
                <div class="field-value">
                  <auto-number-input
                    v-model="job.copyNumber"
                    no="chargeWeight"
                    :min="1"
                    :enforce-min="true"
                    @change="p=>callCopyHandler(p)"
                  />
                </div>
              </div>
            </div>
            <!--            自定义岗位1-->
            <div v-if="item.code === SystemConstants.USER_DEFINED_ROLE_ID_1.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="userDefinedRoleId1"
                    no="userDefinedRoleId1"
                    :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                    :default-value="job.userDefinedRoleId1||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.userDefinedRole1 : []) : []"
                    @change="p=>{pm.userDefinedRoleId1Handler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            自定义岗位2-->
            <div v-if="item.code === SystemConstants.USER_DEFINED_ROLE_ID_2.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="userDefinedRoleId2"
                    no="userDefinedRoleId2"
                    :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                    :default-value="job.userDefinedRoleId2||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.userDefinedRole2 : []) : []"
                    @change="p=>{pm.userDefinedRoleId2Handler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            海外客服-->
            <div v-if="item.code === SystemConstants.OVERSEA_OP.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.OverseaCustomerService') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.OverseaCustomerService') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="overseaOp"
                    no="overseaOp"
                    :default-value="job.overseaOp||''"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.overseaOp : []) : overseaAgentUsersList"
                    :merge-load="true"
                    @change="p=>{job.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            航线负责人-->
            <div v-if="item.code === SystemConstants.PLANNER.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.AirlinePerson2') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.AirlinePerson2') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    ref="planner"
                    no="planner"
                    :method-params="{officeId:job.opOffice,category:'role',shape:'seaLine'}"
                    :default-value="job.planner||''"
                    :merge-load="true"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.seaLine : []) : []"
                    @change="p=>{job.planner=p.value;pm.txtPlannerChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            目的港代理-->
            <div v-if="item.code === SystemConstants.DESTINATION_AGENT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('queryJob.destinationAgent') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('queryJob.destinationAgent') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="destinationAgent"
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
                    :default-value="job.destinationAgent||''"
                    filterable
                    :headers="[$t('Partners.englishName')]"
                    :fields="['englishName']"
                    tag-name="englishName"
                    @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                  />
                  <cargo-advance-select
                    v-if="overseaAgentDataProviderChange"
                    no="destinationAgent2"
                    :select-type="selectTypeNames.basic_data_Company"
                    :cache="false"
                    :default-value="job.destinationAgent||''"
                    filterable
                    :check-credit="true"
                    :headers="[$t('Partners.englishName')]"
                    :fields="['englishName']"
                    tag-name="englishName"
                    :static-options="pm.destinationAgentArray"
                    @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            换单代理-->
            <div v-if="item.code === SystemConstants.EXCHANGE_AGENT.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.BillExchangeAgent') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.BillExchangeAgent') }}</div>
                <div class="field-value">
                  <cargo-company-select
                    ref="exChangeAgent"
                    no="exChangeAgent"
                    :method-params="{bookingAgent:true,active:true}"
                    :default-value="job.exChangeAgent||''"
                    @change="onExChangeAgentChange"
                  />
                </div>
              </div>
            </div>
            <!--            船代-->
            <div v-if="item.code === SystemConstants.CARRIER_AGENT_ID.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CarrierAgent') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CarrierAgent') }}</div>
                <div class="field-value">
                  <cargo-company-select
                    ref="carrierAgentId"
                    no="carrierAgentId"
                    :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
                    :default-value="job.carrierAgentId||''"
                    @change="p=>{job.carrierAgentId=p.value;initIfAutoBookingHandle(job)}"
                  />
                </div>
              </div>
            </div>
            <!--            仓库供应商-->
            <div v-if="item.code === SystemConstants.SUPPLIER_ID.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.WarehouseSupplier') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.WarehouseSupplier') }}</div>
                <div class="field-value">
                  <cargo-company-select
                    ref="warehouseCmp"
                    no="warehouseCmp"
                    :method-params="{warehouse:true,active:true}"
                    :default-value="job.warehouseCmp||''"
                    :placeholder="$t('SeaExport.PleaseSelectWarehouse')"
                    @change="p=>{pm.warehouseCmpChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            仓库名称-->
            <div v-if="item.code === SystemConstants.WAREHOUSE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.WareHouseName') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.WareHouseName') }}</div>
                <div class="field-value">
                  <el-select
                    ref="warehouseName"
                    v-model="job.warehouseName"
                    no="warehouseName"
                    :disabled="!job.warehouseCmp"
                    :allow-create="true"
                    filterable
                    :clearable="true"
                    @change="warehouseNameChangeHandler"
                  >
                    <el-option
                      v-for="(item,index) in warehouseNameList"
                      :key="index"
                      :label="item.warehouseName"
                      :value="item.warehouseName"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <!--            报关行-->
            <div v-if="item.code === SystemConstants.CUSTOMS_BROKER.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CustomsBroker') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CustomsBroker') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="customsBroker"
                    :select-type="selectTypeNames.basic_data_Company"
                    :data-filter-function="customsBrokerFilter"
                    filterable
                    :default-value="job.customsBroker||''"
                    :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                    :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
                    @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
                  />
                </div>
              </div>
            </div>
            <!--            现场操作-->
            <div v-if="item.code === SystemConstants.SITE_OP.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.FieldOperation') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.FieldOperation') }}</div>
                <div class="field-value">
                  <cargo-user-select
                    :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
                    :default-value="job.siteOP||''"
                    :static-options="jobViewInfoMap.get(job.index) ? (jobViewInfoMap.get(job.index).userPortRoleData ? jobViewInfoMap.get(job.index).userPortRoleData.siteOp : []) : []"
                    @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
                  />
                </div>
              </div>
            </div>
            <!--            船司内部航次-->
            <div v-if="item.code === SystemConstants.CARRIER_VOYAGE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.CarrierVoyage') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.CarrierVoyage') }}</div>
                <div class="field-value">
                  <el-input v-model="job.carrierVoyage" />
                </div>
              </div>
            </div>
            <!--            MB/L No.-->
            <div v-if="item.code === SystemConstants.MBL_NO.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ 'MB/L No.' }}</div>
              <div class="item4">
                <div class="field-label">{{ 'MB/L No.' }}</div>
                <div class="field-value">
                  <el-input v-model="job.mbl" />
                </div>
              </div>
            </div>
            <!--            S/O No.-->
            <div v-if="item.code === SystemConstants.SO_NO.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ 'S/O No.' }}</div>
              <div class="item4">
                <div class="field-label">{{ 'S/O No.' }}</div>
                <div class="field-value">
                  <so-no-input v-model="job.soNo" />
                </div>
              </div>
            </div>
            <!--            航线代码-->
            <div v-if="item.code === SystemConstants.ROUTE_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_AirlineCode') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_AirlineCode') }}</div>
                <div class="field-value">
                  <el-input v-model="job.routeCode" />
                </div>
              </div>
            </div>
            <!--            业务标记-->
            <div v-if="item.code === SystemConstants.BUSINESS_MARK.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('CargoMsg.Cargo_BusinessMark') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('CargoMsg.Cargo_BusinessMark') }}</div>
                <div class="field-value">
                  <cargo-advance-select
                    no="businessMark"
                    filterable
                    :select-type="selectTypeNames.local_cache_SystemConstants$BUSINESS_MARK_LIST"
                    :default-multiple-value="job.businessMark"
                    :multiple="true"
                    callback-method-type="value"
                    @parentCallBack="p=>job.businessMark=[...p]"
                  />
                </div>
              </div>
            </div>
            <!--卸货港代码-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_DISCHARGE_PORT_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.PortCodeOfDischarge') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.PortCodeOfDischarge') }}</div>
                <div class="field-value">
                  <el-input v-model="job.portCode" />
                </div>
              </div>
            </div>

            <!--发货人code-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_SHIPPER_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ShipperCode') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.ShipperCode') }}</div>
                <div class="field-value">
                  <el-input
                    v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    v-model="job.shipperCode"
                  />
                  <cargo-advance-select
                    v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    no="shipperId"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :default-value="job.shipperId||''"
                    :method-params="{ shipper: true, active: true }"
                    @parentCallBack="p=>{job.shipperId=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--收货人code-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_CONSIGNEE_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.ConsigneeCode') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.ConsigneeCode') }}</div>
                <div class="field-value">
                  <el-input
                    v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    v-model="job.consigneeCode"
                  />
                  <cargo-advance-select
                    v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    no="consigneeId"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :default-value="job.consigneeId||''"
                    :method-params="{ consignee: true, active: true }"
                    @parentCallBack="p=>{job.consigneeId=p.value}"
                  />
                </div>
              </div>
            </div>
            <!--通知人code-->
            <div v-if="item.code === SystemConstants.OCR_FIELD_NOTIFY_CODE.code" class="row">
              <div class="item1" :style="{ color: getFieldColor(item) }">{{ $t('SeaExport.NotifyPartyCode') }}</div>
              <div class="item4">
                <div class="field-label">{{ $t('SeaExport.NotifyPartyCode') }}</div>
                <div class="field-value">
                  <el-input
                    v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    v-model="job.notifyCode"
                  />
                  <cargo-advance-select
                    v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                    no="notifyId"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :default-value="job.notifyId||''"
                    :method-params="{ notify: true, active: true }"
                    @parentCallBack="p=>{job.notifyId=p.value}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--船司特定代码-->
        <div v-if="shippingCompanySpecificCodeInvisible" class="row">
          <div class="item1" :style="{ color: '#8c8d8e' }">{{ $t('SeaExport.CarrierSpecificCode') }}</div>
          <div class="item4">
            <div class="field-label">{{ $t('SeaExport.CarrierSpecificCode') }}</div>
            <div class="field-value">
              <cargo-advance-select
                no="shippingCompanySpecificCode"
                filterable
                :static-options="shippingCompanySpecificCodeList"
                :allow-create="true"
                tag-name="shippingCompanySpecificCode"
                tag-value="shippingCompanySpecificCode"
                :filter-tag-names="['shippingCompanySpecificCode']"
                @parentCallBack="p=>{job.shippingCompanySpecificCode = p.value}"
              />
            </div>
          </div>
        </div>
        <!--约价性质-->
        <div v-if="bookingTermShow" class="row">
          <div class="item1" :style="{ color: '#8c8d8e' }">{{ $t('SeaExport.ContractRateProperty') }}</div>
          <div class="item4">
            <div class="field-label">{{ $t('SeaExport.ContractRateProperty') }}</div>
            <div class="field-value">
              <el-select
                v-model="job.bookingTerm"
                no="bookingTerm"
                filterable
                :clearable="true"
              >
                <el-option
                  v-for="(item,index) in SeaExportConstants.BOOKING_TERMS"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--字段校验弹窗-->
    <el-dialog
      no="fieldValidDialog"
      :visible.sync="fieldValidDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
    >
      <div v-for="(fieldValidResultByBook,index) in fieldValidDialog.fieldValidResults" :key="index">
        <div>{{ $t('CargoMsg.Cargo_Book') + (fieldValidResultByBook.index + 1) }}</div>
        <el-table
          :data="fieldValidResultByBook.data"
          style="width: 100%"
        >
          <el-table-column
            prop="fieldName"
            :label="$t('CargoMsg.Cargo_FieldName')"
            width="180"
          />
          <el-table-column
            prop="exceptionReason"
            :label="$t('CargoMsg.Cargo_ErrorCause')"
            width="400"
          />
        </el-table>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="fieldValidDialog.visible = false">{{ $t('Message.GotIt') }}</el-button>
      </div>
    </el-dialog>
    <!--船期选择器-->
    <shipping-schedule-dialog
      ref="voyageShowDialog"
      append-to-body
      :visible.sync="voyageShowDialog"
      :callback="callbackShippingScheduleHanle"
    />
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES, FCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { deepClone } from '@/utils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import {
  BRING_OUT_LOGIC_CALL_SOURCE_OCR, BUSINESS_MARK_1, EDI_TEMPLATE_TYPE_BOOKING,
  IF_AUTO_BOOKING,
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_MAP, SE, SENDING_0,
  UPLOAD_STATUS_COMPLETE_ORDER
} from '@/class/cargo/model/parameters/SystemConstants'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import { checkSensitiveWord } from '@/api/basicData/sensitiveWord'
import {
  CARGO_ENGLISH_NAME
} from '@/views/cargo/v0/Information/components/sensitiveWord/SensitiveWordConstant'
import { getLoading } from '@/utils/utilBaseElement'
import {
  CARGOTYPE_CHEMICAL,
  CARGOTYPE_DANGEROUS,
  CARGOTYPE_GENERAL,
  FCL
} from '@/class/cargo/model/parameters/ImportConstants'
import { Company } from '@/class/model/mdm/Company'
import { getcmpIdxByShipCompanyCode, namePrefixMatch } from '@/api/company'
import { isNumber } from '@/utils/validate'
import { CONVERSION_HC } from '@/class/cargo/model/parameters/EqType'
import { loadSpecificBasicInfo } from '@/api/cache'
import shippingScheduleDialog from '@/components/Cargo/Job/shippingScheduleDialog.vue'
import { queryShippingSchedule } from '@/api/voyage'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import { TabBookingFCLPM } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLPM'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { isContractExpiredForbidCreateJobs } from '@/api/partner/contract'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import soNoInput from '@/components/Cargo/Job/soNoInput.vue'
import OcrUtils from '@/utils/OcrUtils'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'ResultFormSe',
  components: {
    soNoInput, CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect,
    CargoPackingSelect, cargoCompanySelect, cargoOfficeSelect, cargoDepartmentSelect, shippingScheduleDialog },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
    // otherField: {
    //   type: Object,
    //   default: () => ({})
    // }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      pm: new TabBookingFCLPM(this),
      CargoSource,
      JobUtils,
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      SeaExportConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      useCase: SENDING_0.code, // 0 海运出口 1 空运出口
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      // otherField: {},
      expressList: [],
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      mapperTexts: [],
      port: new Map(),
      carrier: new Map(),
      orderType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      shippingCompanySpecificCodeList: [],
      shippingCompanySpecificCodeInvisible: false,
      shippingCompanyList: [],
      job: {
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        csrDepartment: 0,
        csrOffice: 0,
        dcDepartment: 0,
        dcOffice: 0,
        agentRefNo: '',
        customerId: 0,
        warehouseNo: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        etd: null,
        paymentTermMBL: '',
        seaEQ: [],
        incoTerm: '',
        customerContact: '',
        measurements: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        quantityContract: 0,
        packing: '',
        cubageContract: 0,
        weightContract: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',
        orderType: 0,
        containerLoadType: '',
        freightTerm: '',
        customerRefNo: '',
        cargoSource: '',
        arriveDate: null,
        customCutoff: null,
        customerCutoff: null,
        customerShutout: null,
        customerFileCutoff: null,
        csr: 0,
        dc: 0,
        scNo: '',
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        cargoChineseName: '',
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        sales: 0,
        op: 0,
        cargoType: '',
        salesOffice: 0,
        salesDepartment: 0,
        opOffice: 0,
        opDepartment: 0,
        bookingAgent: 0,
        vesselCode: '',
        ifAutoBooking: 0,
        ifContainSensitiveWord: false,
        novcc: '',
        tliNo: '',
        amount: 0,
        currency: '',
        customerReserveVoyage: '',
        copyNumber: 1,
        userDefinedRoleId1: 0,
        userDefinedRoleId2: 0,
        overseaOp: 0,
        planner: 0,
        destinationAgent: 0,
        exChangeAgent: 0,
        carrierAgentId: 0,
        warehouseCmp: 0,
        warehouseName: '',
        customsBroker: 0,
        siteOP: 0,
        businessMark: [0],
        routeCode: '',
        soNo: '',
        mbl: '',
        carrierVoyage: '',
        portCode: '',
        shipperCode: '',
        shipperId: '',
        consigneeCode: '',
        consigneeId: '',
        notifyCode: '',
        notifyId: '',
        bookingTerm: 'OS' // 默认 自有约价
      },
      initJob: {
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        csrDepartment: 0,
        csrOffice: 0,
        dcDepartment: 0,
        dcOffice: 0,
        agentRefNo: '',
        customerId: 0,
        warehouseNo: '',
        shipper: '',
        consignee: '',
        notify: '',
        paymentData: '',
        carrierId: 0,
        vessel: '',
        voyageFlight: '',
        etd: null,
        paymentTermMBL: '',
        seaEQ: [],
        incoTerm: '',
        customerContact: '',
        measurements: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        quantityContract: 0,
        packing: '',
        cubageContract: 0,
        weightContract: 0,
        mark: '',
        cargoEnglishName: '',
        remarks: '',
        orderType: 0,
        containerLoadType: '',
        freightTerm: '',
        customerRefNo: '',
        cargoSource: '',
        arriveDate: null,
        customCutoff: null,
        customerCutoff: null,
        customerShutout: null,
        customerFileCutoff: null,
        csr: 0,
        dc: 0,
        scNo: '',
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        cargoChineseName: '',
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        sales: 0,
        op: 0,
        cargoType: '',
        salesOffice: 0,
        salesDepartment: 0,
        opOffice: 0,
        opDepartment: 0,
        bookingAgent: 0,
        vesselCode: '',
        ifAutoBooking: 0,
        ifContainSensitiveWord: false,
        novcc: '',
        tliNo: '',
        amount: 0,
        currency: '',
        copyNumber: 1,
        customerReserveVoyage: '',
        userDefinedRoleId1: 0,
        userDefinedRoleId2: 0,
        overseaOp: 0,
        planner: 0,
        destinationAgent: 0,
        exChangeAgent: 0,
        carrierAgentId: 0,
        warehouseCmp: 0,
        warehouseName: '',
        customsBroker: 0,
        siteOP: 0,
        businessMark: [0],
        routeCode: '',
        soNo: '',
        mbl: '',
        carrierVoyage: ''
      },
      paymentTermMBL: null,
      branchOfficeCheck: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      IF_AUTO_BOOKING, OCR_FIELD_MAP,
      otherField: null,
      ocrRecognitionFields: [], // ocr识别字段
      ocrOtherFields: [], // 额外录单字段
      currentOcrRecognitionFields: [], // 当前 ocr识别字段
      currentOcrOtherFields: [], // 当前 额外录单字段
      fieldValidDialog: {
        visible: false,
        fieldValidResults: [] // 字段校验结果
      },
      fieldDefineMap: {}, // 字段定义
      firstEntry: true, // 首次进入时，字段、value框的颜色为默认值
      showBookRecognitionResults: false, // 展示托书识别结果
      vesselList: [], // 船名下拉列表
      showChooseShippingSchedulesBtn: false, // 显示【选择船期】 按钮
      voyageShowDialog: false,
      overseaAgentDataProviderChange: false, // 目的港代理数据源是否发生变更
      overseaAgentUsersList: [],
      warehouseNameList: [],
      incoTermZDList: ['FOB', 'EXW'], // 贸易条款 指定货
      incoTermZLList: ['FCA', 'CIF', 'DAP', 'DDU', 'DDP', 'CFR', 'CIP', 'CPT'], // 贸易条款 自揽货
      voyageShowDialogData: {
        etd: '',
        vesselId: '',
        voyageNo: '',
        loadingPortCode: '',
        transferPortCode: false,
        transfering: false,
        dischargingPortCode: '',
        routeCode: ''
      },
      jobViewInfoMap: new Map(),
      userPortRoleData: {},
      ediBookingTemplates: [] // edi订舱模板
    }
  },
  computed: {
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    },
    bookingTermShow() {
      /**
       * 识别类型是海运托书、是否自动订舱 是、船公司对应的EVERGREEN LINE则展示
       */
      if (this.shippingCompanyList && this.shippingCompanyList.length > 0 && this.job.carrierId) {
        if (this.shippingCompanyList.includes(this.job.carrierId) && this.job.ifAutoBooking) {
          return true
        } else {
          return false
        }
      }
      return false
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    },
    index(val, oldVal) {
      if (val !== oldVal) {
        // this.init()
        this.resultJson = this.resultArray[val].text.data
        this.job = this.resultJson.jobJson
        this.setDefaultValue()
        this.form = this.job
        this.userPortRoleData = this.jobViewInfoMap.get(this.job.index).userPortRoleData
        this.paymentTermMBL = this.job.paymentTermMBL
      }
    },
    'job.ifAutoBooking': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.cargoEnglishNameCheckSensitiveWord(this.job)
        }
      }
    },
    'job.carrierId': {
      async handler(newVal) {
        this.shippingCompanySpecificCodeInvisible = false
        this.job.shippingCompanySpecificCode = ''
        if (newVal) {
          const company = await Company.getCompanyById(newVal)
          if (company) {
            if (company.chineseName === SystemConstants.RECEIPT_CARRIER_HMM.code || company.shortName === SystemConstants.RECEIPT_CARRIER_HMM.code ||
              company.englishName === SystemConstants.RECEIPT_CARRIER_HMM.code || company.cnShortName === SystemConstants.RECEIPT_CARRIER_HMM.code) {
              this.shippingCompanySpecificCodeInvisible = true
            }
          }
        }
      },
      immediate: true // 可选：是否在初始加载时立即执行
    },
    bookingTermShow(newVal) {
      this.job.bookingTerm = ''
      if (newVal) {
        // 当显示时，设置默认值
        this.job.bookingTerm = SeaExportConstants.BOOKING_TERM_OS.code
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.pm.init()
    await cache.load(cacheName.CONFIG, cacheName.OFFICE)
    this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
    }).catch(() => {
    })
    // 查询EVERGREEN LINE关联平台船公司的
    getcmpIdxByShipCompanyCode('EMC').then(res => {
      if (res && res.data && Array.isArray(res.data)) {
        this.shippingCompanyList = res.data.map(item => item.cmpIdx)
      }
    }).catch(() => {
    })
    queryShippingSchedule({ pageNum: 1, pageSize: 1, startDate: DateUtils.customFormat(new Date(), 'YYYY-MM-DD') }).then(res => {
      this.showChooseShippingSchedulesBtn = parseInt(res.data.total) > 0
    }).catch(() => {
    })
    await getEDITemplate({}).then(result => {
      if (result.data && result.data.length > 0) {
        this.ediBookingTemplates = result.data.filter(p => p.officeIdList &&
          (p.officeIdList.indexOf(this.$store.getters.currentOfficeId) >= 0 || p.officeIdList.indexOf(1) >= 0) &&
          p.templateType === EDI_TEMPLATE_TYPE_BOOKING && p.ifAutoBooking === true
        )
      }
    })
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      await this.initOcrSet()
      // 【已录单】的托书，字段展示历史的
      if (this.details.status === UPLOAD_STATUS_COMPLETE_ORDER.code && this.resultArray[0].ocrRecognitionFields && this.resultArray[0].ocrRecognitionFields.length > 0) {
        this.currentOcrRecognitionFields = this.resultArray[0].ocrRecognitionFields
        this.currentOcrOtherFields = this.resultArray[0].ocrOtherFields
      } else {
        this.currentOcrRecognitionFields = this.ocrRecognitionFields
        this.currentOcrOtherFields = this.ocrOtherFields
      }
      this.initOther()
      this.shippingCompanySpecificCodeList = [
        { shippingCompanySpecificCode: this.$t('SeaExport.textiles') },
        { shippingCompanySpecificCode: this.$t('SeaExport.nonTextiles') }]
      for (let i = 0; i < this.resultArray.length; ++i) {
        const result = this.resultArray[i]
        const resultJson = result.text.data
        const emailResultJson = result.emailText ? result.emailText.data : {}
        const finalResultJson = OcrUtils.getFinalResultJson(resultJson, emailResultJson, this.otherField, this.fieldDefineMap)
        this.jobViewInfoMap.set(i, { userPortRoleData: {}})
        this.userPortRoleData = this.jobViewInfoMap.get(i).userPortRoleData
        // 将json信息转换成对应的值
        if (!resultJson.jobJson) {
          resultJson.jobJson = deepClone(this.initJob)
          resultJson.jobJson.index = i
          // 将finalResultJson赋值给jobJson
          Object.assign(resultJson.jobJson, finalResultJson)
          await this.initJobJson(resultJson.jobJson, finalResultJson)
          this.form = resultJson.jobJson
          // 加载 岗位信息
          await this.loadRelationPosition()
          // 初始化时，备份jobJson，用于统计准确率（业务保存成功，异步进行统计）
          resultJson.originJobJson = deepClone(resultJson.jobJson)
        } else {
          resultJson.jobJson.index = i
          this.form = resultJson.jobJson
          // // 加载 岗位信息
          // await this.loadRelationPosition()
          // 加载 岗位信息
          await this.customerIdChangeHandlerOcr2()
        }
        // console.log('resultJson.jobJson:', resultJson.jobJson)
      }
      setTimeout(() => {
        this.resultJson = this.resultArray[this.index].text.data
        this.job = this.resultJson.jobJson
        this.paymentTermMBL = this.job.paymentTermMBL
        this.form = this.job
        this.setDefaultValue()
        this.userPortRoleData = this.jobViewInfoMap.get(this.job.index).userPortRoleData
        this.firstEntry = false
      }, 100)
    },
    setDefaultValue() {
      if (!this.job.copyNumber) {
        this.job.copyNumber = 1
      }
      let hasBusinessMark = false
      if (this.currentOcrOtherFields && this.currentOcrOtherFields.length > 0) {
        for (const item of this.currentOcrOtherFields) {
          if (item && item.code === SystemConstants.BUSINESS_MARK.code) {
            hasBusinessMark = true
            break
          }
        }
      }
      if (hasBusinessMark) {
        if (!this.job.businessMark || this.job.businessMark.length === 0) {
          this.job.businessMark = [0]
        }
      } else {
        this.job.businessMark = []
      }
    },
    async loadRelationPosition() {
      // 初始化【委托单位】
      const company = await Company.getCompanyById(this.form.customerId)
      await this.customerIdChangeHandlerOcr(company)
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    },
    async initJobJson(job, resultJson) {
      // 箱型、箱量
      this.setSeaEq(job, resultJson)
      this.convertMapper(job, resultJson)

      // 件数
      const quantityContract = this.changeValue(resultJson, 'quantityContract', ['CASE', 'PKGS', 'CTNS'])
      if (quantityContract !== 0) {
        job.quantityContract = Number(!StrUtils.isEmpty(job.packing) && typeof quantityContract === 'string' ? quantityContract.replace(job.packing, '') : quantityContract)
        job.quantityActual = job.quantityContract
      }
      // 毛重
      const weightContract = this.changeValue(resultJson, 'weightContract', ['KGS', this.$t('SeaExport.KG'), ','])
      job.weightContract = Number(weightContract)
      job.weightActual = job.weightContract
      // 体积
      const cubageContract = this.changeValue(resultJson, 'cubageContract', ['CBM', this.$t('SeaExport.CBM')])
      job.cubageContract = Number(cubageContract)
      job.cubageActual = job.cubageContract

      // 交货地 卸货港魏空时，互相赋值
      if (!job.destinationPortCode && job.dischargingPortCode) {
        job.destinationPortCode = job.dischargingPortCode
      } else if (!job.dischargingPortCode && job.destinationPortCode) {
        job.dischargingPortCode = job.destinationPortCode
      }

      // 整拼类型识别为空时，默认"整箱"
      if (!job.containerLoadType) {
        job.containerLoadType = FCL.code
      }
      // 货物类型识别为空时，默认"普货"
      if (!job.cargoType) {
        job.cargoType = CARGOTYPE_GENERAL.code
      }
      // 初始化 操作公司(一定要放在操作部门赋值前面，因为操作部门会根据操作分公司去查)
      job.opOffice = this.$store.getters.currentOfficeId
      // 初始化 操作
      if (!job.op) {
        job.op = this.$store.getters.userId
      }
      // 初始化 操作部门
      const user = await User.getUserById(job.op)
      if (user) {
        this.txtOPChangeHandler(user, job)
      }
      // 初始化 销售部门、销售公司
      if (job.sales) {
        const user = await User.getUserById(job.sales)
        if (user) {
          await this.salesChangeHandler(user, job)
        }
      }
      // 初始化【是否自动订舱】及其disabled状态
      await this.initIfAutoBookingHandle(job)
      this.cargoEnglishNameCheckSensitiveWord(job)
      // 初始化【船舶呼号】
      if (job.vessel) {
        const currentVessel = this.vesselList.filter(p => p.englishName === job.vessel)[0]
        // 无值不清空
        if (currentVessel && currentVessel.callSign) {
          job.vesselCode = currentVessel.callSign
        }
      }
      job.lob = SE.code
      job.customs = true
      job.warehousing = true
      job.warehouseInfo = []
    },
    // 英文品名敏感词校验，如下字段变更需要重新校验【job.loadingPortCode、job.dischargingPortCode、job.carrierId】
    cargoEnglishNameCheckSensitiveWord(job) {
      if (job.ifAutoBooking && job.cargoEnglishName) {
        const loading = getLoading()
        checkSensitiveWord({ job, wordField: CARGO_ENGLISH_NAME.code }).then(res => {
          job.ifContainSensitiveWord = res.data.ifContainSensitiveWord
          job.matchedSensitiveWords = res.data.matchedSensitiveWords
        }).finally(() => {
          loading.close()
        })
      } else {
        job.ifContainSensitiveWord = false
      }
    },
    // 字段校验
    async fieldValid() {
      // 委托单位合同到期，不能创建业务校验
      const cmpIdxList = new Set()
      for (let i = 0; i < this.resultArray.length; ++i) {
        const jobJson = this.resultArray[i].text.data.jobJson
        if (jobJson.customerId) {
          cmpIdxList.add(jobJson.customerId)
        }
      }
      const contractExpiredCmpIdxList = []
      if (cmpIdxList.size > 0) {
        await isContractExpiredForbidCreateJobs(Array.from(cmpIdxList)).then(res => {
          if (res.data && res.data.length > 0) {
            contractExpiredCmpIdxList.push(...res.data)
          }
        })
      }
      if (this.otherField.ocrOtherFieldDetails && this.otherField.ocrOtherFieldDetails.length > 0) {
        const fieldValidResultsMap = new Map()
        // 必填项 校验
        const requiredFieldDetails = this.otherField.ocrOtherFieldDetails.filter(item => !!item.ifRequired && !!item.ifCheck)
        if (requiredFieldDetails && requiredFieldDetails.length > 0) {
          for (let i = 0; i < this.resultArray.length; ++i) {
            const result = this.resultArray[i]
            const fieldValidResultByBook = {
              index: i,
              data: []
            }
            const job = result.text.data.jobJson
            for (const fieldDetail of requiredFieldDetails) {
              // 保存业务必填校验、订舱必填校验
              if (fieldDetail.ifRequired.split(',').length > 1 || fieldDetail.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code || job.ifAutoBooking) {
                if (!job[fieldDetail.code] || (Array.isArray(job[fieldDetail.code]) && job[fieldDetail.code].length === 0)) {
                  fieldValidResultByBook.data.push({
                    fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, this.useCase),
                    exceptionReason: this.$t('queryJob.CannotBeEmpty')
                  })
                } else if (fieldDetail.code === SystemConstants.OCR_FIELD_CUSTOMER_ID.code) {
                  if (contractExpiredCmpIdxList.indexOf(job[fieldDetail.code]) > -1) {
                    fieldValidResultByBook.data.push({
                      fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, this.useCase),
                      exceptionReason: this.$t('Message.ContractExpireCannotCreated')
                    })
                  }
                }
              }
            }
            if (fieldValidResultByBook.data.length > 0) {
              // this.fieldValidDialog.fieldValidResults.push(fieldValidResultByBook)
              fieldValidResultsMap.set(i, fieldValidResultByBook)
            }
          }
        }
        // OCR-业务标记选择包含"转运"，点击【生成业务】判断中转港必填,未填写提示：请选择"中转港"
        for (let i = 0; i < this.resultArray.length; ++i) {
          const result = this.resultArray[i]
          const job = result.text.data.jobJson
          const fieldValidResultByBook = {
            index: i,
            data: []
          }
          if (job.businessMark && job.businessMark.includes(BUSINESS_MARK_1.code) && !job.transferPortCode) {
            fieldValidResultByBook.data.push({
              fieldName: this.$t('Payment.portOfTransfer'),
              exceptionReason: this.$t('CargoMsg.Cargo_PortOfTransferCheck')
            })
            if (fieldValidResultByBook.data.length > 0) {
              fieldValidResultsMap.set(i, fieldValidResultByBook)
            }
          }
        }
        // 船公司为【ONE、HMM】时，进行 收发通 长度校验
        // for (let i = 0; i < this.resultArray.length; ++i) {
        //   const result = this.resultArray[i]
        //   const job = result.text.data.jobJson
        //   if (job.carrierId && (job.shipper || job.consignee || job.notify)) {
        //     const carrier = await Company.getCompanyById(parseInt(job.carrierId))
        //     // 匹配 code、简称、中文名、英文名
        //     if (ADDRESS_VALID_CARRIER.indexOf(carrier.cnShortName) >= 0 || ADDRESS_VALID_CARRIER.indexOf(carrier.shortName) >= 0 ||
        //       ADDRESS_VALID_CARRIER.indexOf(carrier.chineseName) >= 0 || ADDRESS_VALID_CARRIER.indexOf(carrier.englishName) >= 0) {
        //       // 行数校验
        //       let fieldValidResultByBook = fieldValidResultsMap.get(i)
        //       if (!fieldValidResultByBook) {
        //         fieldValidResultByBook = {
        //           index: i,
        //           data: []
        //         }
        //       }
        //       const maxRows = [carrier.cnShortName, carrier.shortName, carrier.chineseName, carrier.englishName].indexOf('ONE') >= 0 ? 9 : 6
        //       if (job.shipper && job.shipper.split('\n').length > maxRows && job.ifAutoBooking) {
        //         fieldValidResultByBook.data.push({
        //           fieldName: OCR_FIELD_MAP.get(OCR_FIELD_SHIPPER.code),
        //           exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //         })
        //         if (!fieldValidResultsMap.has(i)) {
        //           fieldValidResultsMap.set(i, fieldValidResultByBook)
        //         }
        //       } else {
        //         for (let j = 0; j <= 7; ++j) {
        //           if (job['shipperLine' + j] && job['shipperLine' + j].length > 35 && job.ifAutoBooking) {
        //             fieldValidResultByBook.data.push({
        //               fieldName: OCR_FIELD_MAP.get(OCR_FIELD_SHIPPER.code),
        //               exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //             })
        //             if (!fieldValidResultsMap.has(i)) {
        //               fieldValidResultsMap.set(i, fieldValidResultByBook)
        //             }
        //             break
        //           }
        //         }
        //       }
        //       if (job.consignee && job.consignee.split('\n').length > maxRows && job.ifAutoBooking) {
        //         fieldValidResultByBook.data.push({
        //           fieldName: OCR_FIELD_MAP.get(OCR_FIELD_CONSIGNEE.code),
        //           exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //         })
        //         if (!fieldValidResultsMap.has(i)) {
        //           fieldValidResultsMap.set(i, fieldValidResultByBook)
        //         }
        //       } else {
        //         for (let j = 0; j <= 7; ++j) {
        //           if (job['consigneeLine' + j] && job['consigneeLine' + j].length > 35 && job.ifAutoBooking) {
        //             fieldValidResultByBook.data.push({
        //               fieldName: OCR_FIELD_MAP.get(OCR_FIELD_CONSIGNEE.code),
        //               exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //             })
        //             if (!fieldValidResultsMap.has(i)) {
        //               fieldValidResultsMap.set(i, fieldValidResultByBook)
        //             }
        //             break
        //           }
        //         }
        //       }
        //       if (job.notify && job.notify.split('\n').length > maxRows && job.ifAutoBooking) {
        //         fieldValidResultByBook.data.push({
        //           fieldName: OCR_FIELD_MAP.get(OCR_FIELD_NOTIFY.code),
        //           exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //         })
        //         if (!fieldValidResultsMap.has(i)) {
        //           fieldValidResultsMap.set(i, fieldValidResultByBook)
        //         }
        //       } else {
        //         for (let j = 0; j <= 7; ++j) {
        //           if (job['notifyLine' + j] && job['notifyLine' + j].length > 35 && job.ifAutoBooking) {
        //             fieldValidResultByBook.data.push({
        //               fieldName: OCR_FIELD_MAP.get(OCR_FIELD_NOTIFY.code),
        //               exceptionReason: this.$t('CargoMsg.CannotBeLongerThan35', [maxRows])
        //             })
        //             if (!fieldValidResultsMap.has(i)) {
        //               fieldValidResultsMap.set(i, fieldValidResultByBook)
        //             }
        //             break
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        if (fieldValidResultsMap.size > 0) {
          this.fieldValidDialog.fieldValidResults = Array.from(fieldValidResultsMap.values()).sort((a, b) => a.index - b.index)
          this.fieldValidDialog.visible = true
          return false
        }
      }
      return true
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        result = job[targetField]
        if (typeof result === 'string') {
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    setSeaEq(job, resultJson) {
      try {
        job.seaEQ = []
        if (resultJson.seaEQ) {
          const dataArray = resultJson.seaEQ.split(',')
          for (const data of dataArray) {
            const cData = data.split(/[:]/g)
            const eqData = {}
            eqData.eqQuantity = Number(cData[1] || 1)
            if (cData[0].includes('\'')) {
              const sizeTypeData = cData[0].split(/[']/g)
              eqData.eqSizeOrg = sizeTypeData[0]
              eqData.eqTypeOrg = sizeTypeData[1]
            } else {
              const match = cData[0].match(/^(\d+)([A-Za-z]+)/)
              eqData.eqSizeOrg = match[1]
              eqData.eqTypeOrg = match[2] && match[2].toUpperCase() === CONVERSION_HC.conversionValue ? CONVERSION_HC.originalValue : match[2]
            }
            const eqSize = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.local_cache_EQSize, 'code', eqData.eqSizeOrg, 'code')
            const eqType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_EQType, 'code', eqData.eqTypeOrg, 'code')
            if (eqSize) {
              eqData.eqSize = eqSize
            }
            if (eqType) {
              eqData.eqType = eqType
            }
            // eqData.showEQ = 'X' + eqData.eqSizeOrg + '' + eqData.eqTypeOrg
            job.seaEQ.push(eqData)
          }
        }
      } catch (e) {
        console.log('ResultFormSeCwmi error', e)
      }
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.orderType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    convertMapper(job, resultJson) {
      this.initMapper()
      // 委托单位
      this.mapperCustomerId(job, resultJson)
      // 整箱拼箱
      this.mapperLoadType(job, resultJson)
      // 船公司
      this.mapperShipName(job, resultJson)
      // 开航日期
      this.mapperEtd(job, resultJson)
      // 运输条款
      this.mapperFreightTerm(job, resultJson)
      // 运费条款
      this.mapperPaymentTerm(job, resultJson)
      // 贸易条款
      this.mapperIncoTerm(job, resultJson)
      // 起运港
      this.mapperSeaPort('loadingPortCode', 'loadingPortCode', job, resultJson)
      // 中转港
      this.mapperSeaPort('transferPortCode', 'transferPortCode', job, resultJson)
      // 卸货港
      this.mapperSeaPort('dischargingPortCode', 'dischargingPortCode', job, resultJson)
      // 交货地
      this.mapperSeaPort('destinationPortCode', 'destinationPortCode', job, resultJson)
      // 包装
      this.mapperPacking('', job, resultJson)
      // 提单形式
      this.mapperOrderType(job, resultJson)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: 0, // 应用场景 0海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 文字映射
          this.toMapperText(ocrSet)
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 文字映射
    toMapperText(ocrSet) {
      const mapperList = ocrSet.mapperList || []
      const mapperHqList = ocrSet.mapperHqList || []
      const otherMapper = mapperList.length > 0 ? mapperList[0] : null
      if (otherMapper && otherMapper.ifHq) {
        this.mapperTexts = mapperHqList
      }
      if (!this.mapperTexts || this.mapperTexts.length === 0) {
        this.mapperTexts = mapperList || []
      }
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.orderType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.eq = new Map()
      this.customer = new Map()
      this.packing = new Map()
      const mapperTexts = this.mapperTexts
      if (!mapperTexts || mapperTexts.length <= 0) {
        return
      }
      for (const mapperText of this.mapperTexts) {
        const mapperKey = mapperText.type + '_' + mapperText.useCase + '_' + mapperText.oldText
        const mapperVal = mapperText.newText
        if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PORT.code) {
          this.port.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CARRIER.code) {
          this.carrier.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code) {
          this.orderType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code) {
          this.loadType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code) {
          this.shippingTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code) {
          this.paymentTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code) {
          this.incoTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_EQ.code) {
          this.eq.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code) {
          this.customer.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PACKING.code) {
          this.packing.set(mapperKey, mapperVal)
        }
      }
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      // const fieldList = ocrSet.fieldList || []
      // const fieldHqList = ocrSet.fieldHqList || []
      // let otherField = fieldList.length > 0 ? fieldList[0] : null
      // if (otherField && otherField.ifHq) {
      //   otherField = fieldHqList.length > 0 ? fieldHqList[0] : otherField
      // }
      this.otherField = ocrSet.finalField

      this.fieldDefineMap = ocrSet.fieldDefineMap
      if (this.otherField.ocrOtherFieldDetails) {
        // ocr识别字段
        this.ocrRecognitionFields = this.otherField.ocrOtherFieldDetails.filter(item => this.fieldDefineMap[item.code] && !this.fieldDefineMap[item.code].ifExtraField)
        // 额外录单字段
        this.ocrOtherFields = this.otherField.ocrOtherFieldDetails.filter(item => this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField)
      }
    },
    // 货物列表更改
    onGoodsCellChange() {

    },
    // 委托单位
    mapperCustomerId(job, resultJson) {
      job.customerId = 0
      if (!StrUtils.isEmpty(resultJson.customerId)) {
        // 用解析值 匹配 代码
        let customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.customerId, 'cmpIdx')
        if (!customerId) {
          // 用解析值 匹配 英文名
          customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.customerId, 'cmpIdx')
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.customerId, 'cmpIdx')
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + this.useCase + '_' + resultJson.customerId
              const newMapperVal = this.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        job.customerId = customerId || 0
        // 委托单位 前缀模糊匹配
        if (!job.customerId) {
          namePrefixMatch({ companyName: resultJson.customerId }).then(res => {
            job.customerId = res.data
          })
        }
      }
    },
    // 船公司
    mapperShipName(job, resultJson) {
      job.carrierId = 0
      if (!StrUtils.isEmpty(resultJson.carrierId)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.carrierId, 'cmpIdx')
        carrierId = this.checkOfficeId(carrierId)
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.carrierId, 'cmpIdx')
          carrierId = this.checkOfficeId(carrierId)
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.carrierId, 'cmpIdx')
            carrierId = this.checkOfficeId(carrierId)
            if (!carrierId || Number(carrierId) <= 0) {
              // 用解析值 匹配 简称
              carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', resultJson.carrierId, 'cmpIdx')
              carrierId = this.checkOfficeId(carrierId)
              if (!carrierId || Number(carrierId) <= 0) {
                const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + resultJson.carrierId
                const newMapperVal = this.carrier.get(mapperKey)
                if (newMapperVal) {
                  // 用映射值 匹配 代码
                  carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                  carrierId = this.checkOfficeId(carrierId)
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 英文名
                    carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                    carrierId = this.checkOfficeId(carrierId)
                    if (!carrierId || Number(carrierId) <= 0) {
                      // 用映射值 匹配 中文名
                      carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                      carrierId = this.checkOfficeId(carrierId)
                      if (!carrierId || Number(carrierId) <= 0) {
                        // 用映射值 匹配 简称
                        carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', newMapperVal, 'cmpIdx')
                        carrierId = this.checkOfficeId(carrierId)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        job.carrierId = carrierId || 0
      }
    },
    checkOfficeId(carrierId) {
      if (carrierId && carrierId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carrierId)
        if (company && (!company.seaCmp || !company.active || (company.branchId !== 1 && company.branchId !== this.$store.getters.currentOfficeId &&
          (!company.multipleBranchId || (company.multipleBranchId && !company.multipleBranchId.split(',').includes(String(this.$store.getters.currentOfficeId))))))) {
          carrierId = 0
        }
      }
      return carrierId
    },
    mapperEtd(job, resultJson) {
      let etdStr = resultJson.etd
      // 开航日期无年份，则默认当前年份
      if (etdStr && etdStr.length > 4) {
        const years = etdStr.substring(0, 4)
        if (!isNumber(years)) {
          etdStr = new Date().getFullYear() + '-' + etdStr
        }
      }
      if (etdStr) {
        etdStr = etdStr.replaceAll(/[年月日号.]/g, '-')
        let etd = DateUtils.toDateStr(etdStr)
        if (!etd && etdStr.length > 8) {
          etd = ColumnUtils.dateTimeLabelFunc(etdStr)
        }
        job.etd = etd || ''
      }
    },
    // 整箱拼箱
    mapperLoadType(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.containerLoadType)) {
        // 用解析值 匹配 代码
        let loadType = ContainerLoadType.getContainerLoadTypeByCode(resultJson.containerLoadType)
        let loadTypeCode = loadType ? loadType.code : ''
        if (!loadTypeCode) {
          // 用解析值 匹配 中英文名
          loadType = ContainerLoadType.getContainerLoadTypeByName(resultJson.containerLoadType)
          loadTypeCode = loadType ? loadType.code : ''
          if (!loadTypeCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code + '_' + this.useCase + '_' + resultJson.containerLoadType
            const newMapperVal = this.loadType.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              loadType = ContainerLoadType.getContainerLoadTypeByCode(newMapperVal)
              loadTypeCode = loadType ? loadType.code : ''
              if (!loadTypeCode) {
                // 用映射值 匹配 中英文名
                loadType = ContainerLoadType.getContainerLoadTypeByName(newMapperVal)
                loadTypeCode = loadType ? loadType.code : ''
              }
            }
          }
        }
        job.containerLoadType = loadTypeCode || ''
      }
    },
    // 运输条款
    mapperFreightTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.freightTerm)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', resultJson.freightTerm, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', resultJson.freightTerm, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', resultJson.freightTerm, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + resultJson.freightTerm
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabelFreightTerm(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.freightTermHBL = freightTerm || ''
        job.freightTerm = freightTerm || ''
      }
    },
    // 运费条款
    mapperPaymentTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.paymentTermMBL)) {
        // if (['PP', 'PREPAID'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT PREPAID'
        // } else if (['CC', 'COLLECT'].indexOf(resultJson.paymentTerm.toUpperCase()) > -1) {
        //   resultJson.paymentTerm = 'FREIGHT COLLECT'
        // }
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', resultJson.paymentTermMBL, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', resultJson.paymentTermMBL, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', resultJson.paymentTermMBL, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + resultJson.paymentTermMBL
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        // job.paymentTermHBL = paymenTerm || ''
        job.paymentTermMBL = paymenTerm || ''
      }
    },
    // 贸易条款
    mapperIncoTerm(job, resultJson) {
      if (!StrUtils.isEmpty(resultJson.incoTerm)) {
        // const cifRegex = /\b(CIF)\b/g
        // const fobRegex = /\b(FOB)\b/g
        // const dapRegex = /\b(DAP)\b/g
        // if (cifRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'CIF'
        // } else if (fobRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'FOB'
        // } else if (dapRegex.test(resultJson.incoTerm)) {
        //   resultJson.incoTerm = 'DAP'
        // }
        // 用解析值 匹配 代码
        let incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', resultJson.incoTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 英文名
          incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', resultJson.incoTerm, 'code')
          if (!incoTerm) {
            // 用解析值 匹配 中文名
            incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', resultJson.incoTerm, 'code')
            if (!incoTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + this.useCase + '_' + resultJson.incoTerm
              const newMapperVal = this.incoTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 英文名
                  incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                  if (!incoTerm) {
                    // 用映射值 匹配 中文名
                    incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        job.incoTerm = incoTerm || ''
      }
    },
    // 起运港 中转港 卸货港 交货地
    mapperSeaPort(code = '', jsonCode = '', job, resultJson) {
      if (!code) return
      if (!resultJson[jsonCode]) return
      // 用解析值 匹配 代码
      let portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', resultJson[jsonCode], 'code')
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', resultJson[jsonCode], 'code')
          if (!portCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + resultJson[jsonCode]
            const newMapperVal = this.port.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 英文名
                portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                if (!portCode) {
                  // 用映射值 匹配 中文名
                  portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      // 只比较','前面的部分；比如：shanghai 匹配 shanghai,china
      // if (!portCode) {
      //   // 用解析值 匹配 代码
      //   portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', resultJson[jsonCode], 'code', null, true)
      //   if (!portCode) {
      //     // 用解析值 匹配 英文名
      //     portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', resultJson[jsonCode], 'code', null, true)
      //     if (!portCode) {
      //       // 用解析值 匹配 中文名
      //       portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', resultJson[jsonCode], 'code', null, true)
      //     }
      //   }
      // }
      // CARGO-49588 如果完全匹配没有匹配得上 那就以逗号分割,只要匹配得上，后面就不匹配了
      if (!portCode) {
        // 将中文逗号替换成英文逗号
        const replacedString = resultJson[jsonCode].replace(/，/g, ',')
        // 将字符串按英文逗号分割成数组
        const splitArray = replacedString.split(',')
        // 遍历数组
        for (let i = 0; i < splitArray.length; i++) {
          portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', splitArray[i], 'code')
          if (!portCode) {
            // 用解析值 匹配 英文名
            portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', splitArray[i], 'code')
            if (!portCode) {
              // 用解析值 匹配 中文名
              portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', splitArray[i], 'code')
              if (!portCode) {
                const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + splitArray[i]
                const newMapperVal = this.port.get(mapperKey)
                if (newMapperVal) {
                  // 用映射值 匹配 代码
                  portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
                  if (!portCode) {
                    // 用映射值 匹配 英文名
                    portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                    if (!portCode) {
                      // 用映射值 匹配 中文名
                      portCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                    } else {
                      break
                    }
                  } else {
                    break
                  }
                }
              } else {
                break
              }
            } else {
              break
            }
          } else {
            break
          }
        }
      }
      job[code] = portCode || ''
    },
    // 包装
    mapperPacking(packingVal = '', job, resultJson) {
      let realPacking = resultJson.packing
      if (packingVal) { // 多单模式时 packingVal 有值
        realPacking = packingVal
      }
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          job.packing = packingCode || ''
        }
      }
      return packingCode
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    mapperOrderType(job, resultJson) {
      job.orderType = null
      if (!StrUtils.isEmpty(resultJson.orderType)) {
        let releaseType = null
        const orderType = resultJson.orderType
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + resultJson.orderType
          const newMapperVal = this.orderType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }

        job.orderType = releaseType
      }
    },
    etdChange(value) {
      this.job.etd = value
    },
    // 保存时获取数据
    getSubmitData() {
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    changeSizeCallBack(item, p) {
      item.eqSizeOrg = item.eqSize = p.value
      // item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    changeTypeCallBack(item, p) {
      item.eqTypeOrg = item.eqType = p.value
      // item.showEQ = 'X' + item.eqSizeOrg + '' + item.eqTypeOrg
    },
    // 单证改变
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 当选择销售人员的时候自动关联该销售所在分公司
     */
    async salesChangeHandler(data, job) {
      // const job = this.job
      job.sales = data.value
      job.salesOffice = 0
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === cache.office.officeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
            }
          }
        }
      }
    },
    /**
     * 操作改变
     */
    txtOPChangeHandler(user, job) {
      // const job = this.job
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    getFieldColor(item) {
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code || this.job.ifAutoBooking) {
          return '#1398f1'
        }
      }
      return '#8c8d8e'
    },
    getValueBorderColor(item) {
      // console.log('getValueBorderColor, code:', item.code)
      if (!this.firstEntry && item.ifCheck && item.ifRequired) {
        if (item.ifRequired.split(',').length > 1 || item.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code || this.job.ifAutoBooking) {
          if (!this.job[item.code] || (Array.isArray(this.job[item.code]) && this.job[item.code].length === 0)) {
            return 'red'
          }
        }
      }
      return this.fieldDefineMap[item.code] && this.fieldDefineMap[item.code].ifExtraField ? 'white' : '#cee0c8'
    },
    // 新增 箱型箱量
    addSeaEQ() {
      this.job.seaEQ.push({})
    },
    // 删除 箱型箱量
    deleteSeaEQ(index) {
      this.job.seaEQ.splice(index, 1)
    },
    // 货物类型变更
    cargoTypeHandle() {
      if (!this.job.ifAutoBookingDisabled) {
        if (CARGOTYPE_DANGEROUS.code === this.job.cargoType ||
          CARGOTYPE_CHEMICAL.code === this.job.cargoType) {
          // 危险品、一般化工品
          this.job.ifAutoBooking = false
        } else if (CARGOTYPE_GENERAL.code === this.job.cargoType) {
          // 普货
          this.job.ifAutoBooking = true
        }
      }
      JobUtils.matchUserPortConfig(this, this.job)
    },
    // 初始化【是否自动订舱】及其disabled状态
    async initIfAutoBookingHandle(job) {
      // 1、船公司 为空
      if (!job.carrierId) {
        job.ifAutoBookingDisabled = true
        job.ifAutoBooking = false
        return
      }
      // 2、校验模板
      if (!this.ediBookingTemplates || this.ediBookingTemplates.length === 0) {
        job.ifAutoBookingDisabled = true
        job.ifAutoBooking = false
        return
      }
      const ediBookingTemplate = this.ediBookingTemplates.find(p => p.carrierId === job.carrierId &&
        (p.bookingAgent === 0 || p.bookingAgent === job.bookingAgent) && (p.carrierAgentId === 0 || p.carrierAgentId === job.carrierAgentId))
      if (!ediBookingTemplate) {
        job.ifAutoBookingDisabled = true
        job.ifAutoBooking = false
        return
      }
      // 远程订舱 为否且置灰>验证整拼类型不等于整箱时，为否且置灰>指定船公司的未配置时，为否且置灰>级联逻辑>为空默认值
      if (this.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code || job.containerLoadType !== FCL_CARGO_TYPE.code) {
        job.ifAutoBookingDisabled = true
        job.ifAutoBooking = false
        return
      }
      job.ifAutoBookingDisabled = false
      if (CARGOTYPE_DANGEROUS.code === job.cargoType ||
            CARGOTYPE_CHEMICAL.code === job.cargoType) {
        // 危险品、一般化工品
        job.ifAutoBooking = false
      } else if (CARGOTYPE_GENERAL.code === job.cargoType) {
        // 普货
        job.ifAutoBooking = true
      }
    },
    onExChangeAgentChange(data) {
      this.job.exChangeAgent = data.value
      for (const item of this.job.dischargingTrucking) {
        item.exChangeAgent = data.value
      }
      CargoDocUtil.changeHBLAndHBL2AgentParty(this.job)
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.job.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.job.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    async customerRefNoCheckSensitiveWord(job) {
      job.warehouseNo = ''
      if (this.incoTermZDList.includes(job.incoTerm) || this.incoTermZLList.includes(job.incoTerm)) {
        // 通过job.incoTerm判断是否在指定的列表中，并获取对应的客户信息
        const customer = await Company.getCompanyById(parseInt(job.customerId))
        let isDesignatedOrSelfWarehouse = false

        // 判断是否是指定的货仓或者自有的货仓
        if ((this.incoTermZDList.includes(job.incoTerm) && customer.designatedCargoWarehouseNo) ||
          (this.incoTermZLList.includes(job.incoTerm) && customer.selfCargoWarehouseNo)) {
          isDesignatedOrSelfWarehouse = true
        }

        // 如果是指定的货仓或者自有的货仓，则设置warehouseNo
        if (isDesignatedOrSelfWarehouse) {
          job.warehouseNo = job.customerRefNo
        }
      }
    },
    // 船名变更调整
    async onVesselSelectionChange(data) {
      this.job.vessel = data.value
      // 无值不清空
      if (data.callSign) {
        this.job.vesselCode = data.callSign
      }
    },
    // 打开【选中船期】弹框
    btnVayageShowHandle() {
      this.voyageShowDialog = true
      // etd
      this.voyageShowDialogData.etd = this.job.etd
      // 船名
      this.voyageShowDialogData.vesselId = this.job.vessel
      // 航次
      this.voyageShowDialogData.voyageNo = this.job.voyageFlight
      // 装货港/起运港
      this.voyageShowDialogData.loadingPortCode = this.job.loadingPortCode
      this.voyageShowDialogData.transfering = this.job.transfering
      // 勾选了中转 就将中转港设置为卸货港
      if (this.job.transfering) {
        // 中转港
        this.voyageShowDialogData.dischargingPortCode = this.job.transferPortCode
      } else {
        // 卸货港
        this.voyageShowDialogData.dischargingPortCode = this.job.dischargingPortCode
      }
      // 页面来源：不展示【只看国际航线】、显示【船公司】 高级查询
      this.voyageShowDialogData.pageSource = 'ocr'
      // 船公司
      this.voyageShowDialogData.carrierId = this.job.carrierId
      this.$refs.voyageShowDialog.onshow(this.voyageShowDialogData)
    },
    callCopyHandler(p) {
      this.job.copyNumber = p
    },
    // 【选中船期】选中回调处理
    callbackShippingScheduleHanle(param) {
      // 弹窗关闭
      this.voyageShowDialog = false
      // 船名
      if (param.englishName) {
        this.job.vessel = param.englishName
      }
      // 航次
      if (param.voyageNo) {
        this.job.voyageFlight = param.voyageNo
      }
      // 船舶呼号
      if (param.callSign) {
        this.job.vesselCode = param.callSign
      }
      // etd
      if (param.etd) {
        this.job.etd = param.etd
      }
      // 船公司
      if (param.carrierId) {
        this.job.carrierId = param.carrierId
      }
    },
    clear(item) {
      this.resultJson[item.code + '_notShowPlaceholder'] = true
      this.$forceUpdate()
    },

    /**
     * 委托单位改变处理（ocr识别界面）
     * @param job
     * @param view
     * @param company
     * @returns {Promise<void>}
     */
    async customerIdChangeHandlerOcr(company) {
      // 没有开启isSpecifiedSalesBusiness 时，展示有销售权限用户
      if (!this.pm.isSpecifiedSalesBusiness) {
        if (!this.job.index) {
          this.job.index = 0
        }
        const jobMap = this.jobViewInfoMap.get(this.job.index)
        if (jobMap) {
          this.jobViewInfoMap.get(this.job.index).salesList = await JobUtils.getOfficeSaleList()
          const copiedMap = new Map()
          this.jobViewInfoMap.forEach((value, key) => {
            copiedMap.set(key, value)
          })
          this.jobViewInfoMap = copiedMap
        }
      }
      await this.pm.customerIdChangeJobPropertiesHandler(!company ? 0 : company.cmpIdx, BRING_OUT_LOGIC_CALL_SOURCE_OCR.code)
      if (!company || !company.cmpIdx) {
        return
      }
      this.form.customerId = company.cmpIdx
      this.form.customerContact = await JobUtils.getCustomerContact(company.uuid)
      await this.pm.onCustomerDetailLoad(null, BRING_OUT_LOGIC_CALL_SOURCE_OCR.code)
      this.pm.loadCustomerPortDestinationAgents(false, BRING_OUT_LOGIC_CALL_SOURCE_OCR.code)
      await this.pm.loadCompanyUser(1, BRING_OUT_LOGIC_CALL_SOURCE_OCR.code) // 销售
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    async customerIdChangeHandlerOcr2() {
      if (!this.pm.isSpecifiedSalesBusiness) {
        if (!this.job.index) {
          this.job.index = 0
        }
        const jobMap = this.jobViewInfoMap.get(this.job.index)
        if (jobMap) {
          this.jobViewInfoMap.get(this.job.index).salesList = await JobUtils.getOfficeSaleList()
          const copiedMap = new Map()
          this.jobViewInfoMap.forEach((value, key) => {
            copiedMap.set(key, value)
          })
          this.jobViewInfoMap = copiedMap
        }
      }
      await this.pm.loadCompanyUser(1, BRING_OUT_LOGIC_CALL_SOURCE_OCR.code) // 销售
    },
    /**
     * 显示字段项
     */
    showFieldItem(item, code) {
      return item.code === code && (this.showAll || (item.showField && !this.showAll))
    }

  }
}
</script>

<style lang="scss" scoped>
// 新的表头样式
.header-container {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.column-header {
  font-weight: 600;
  color: #333;
  background-color: #f5f5f5;
  padding: 12px 16px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &.recognition-header {
    flex: 1;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
  }

  &.confirmed-header {
    flex: 1;
    background-color: #e8f5e8;
    border: 1px solid #abd08e;
  }

  &.other-data-header {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    margin-bottom: 16px;
  }

  .toggle-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #409eff;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: #337ecc;
      transform: translateY(-50%) scale(1.05);
    }
  }
}

.result-form-se {
  display: flex;
  .row {
    display: flex;
    align-items: stretch;
    margin-bottom: 8px;
    gap: 20px;
  }
  .item1 {
    display: none; // 隐藏原来的字段标题列
  }
  .item2 {
    width: 100%;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    min-height: 100px;
    pointer-events: none;
    position: relative;
    padding: 16px;
    border: 2px solid #ddd;
    border-radius: 4px;
    background-color: #fff;

    &.field-red-border {
      border-color: #ff4d4f;
    }

    .field-label {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 6px;
      color: #666;
    }

    .field-value {
      flex: 1;
      font-size: 14px;
      color: #333;
      word-wrap: break-word;
      white-space: pre-wrap;
      line-height: 1.4;
      min-height: 20px;

      &.field-value-textarea {
        min-height: 120px;
        max-height: 120px;
        overflow-y: auto;
        white-space: pre-wrap;
        line-height: 1.5;
      }
    }

    // 保持向后兼容
    .field-title {
      background-color: #e8e8e8;
      color: #666;
      font-size: 12px;
      font-weight: 500;
      padding: 4px 8px;
      border-bottom: 1px solid #ddd;
      text-align: left;
    }

    .field-content {
      flex: 1;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      text-align: left;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }
  .item3 {
    width: 100%;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    min-height: 100px;
    position: relative;
    padding: 16px;
    border: 2px solid #ddd;
    border-radius: 4px;
    background-color: #fff;

    .field-label {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 6px;
      color: #666;
    }

    .field-value {
      flex: 1;
      font-size: 14px;
      color: #333;
      min-height: 20px;

      // 让所有表单组件撑满容器宽度
      ::v-deep .el-select {
        width: 100% !important;
      }

      ::v-deep .el-input {
        width: 100% !important;
      }

      ::v-deep .el-input-number {
        width: 100% !important;
      }

      ::v-deep .el-textarea {
        width: 100% !important;
      }

      ::v-deep .cargo-advance-select {
        width: 100% !important;
      }

      ::v-deep .cargo-company-select {
        width: 100% !important;
      }

      ::v-deep .cargo-packing-select {
        width: 100% !important;
      }

      ::v-deep .el-input__inner {
        background-color: white;
      text-align: left;
        border: 1px solid #ddd;
    }

      ::v-deep .el-textarea__inner {
      background-color: white;
        border: 1px solid #ddd;
      }

      // 为textarea字段设置固定高度，确保与左侧对称
      &.field-value-textarea {
        ::v-deep .el-textarea .el-textarea__inner {
          min-height: 144px !important;
          max-height: 144px !important;
          resize: none;
          line-height: 1.5;
          padding: 8px 12px;
          box-sizing: border-box;
        }
      }
    }

    // 保持向后兼容
    .field-title {
      background-color: #f0f0f0;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      padding: 4px 8px;
      border-bottom: 1px solid #ddd;
      text-align: left;
    }

    .field-content {
      flex: 1;
      padding: 8px;
      display: flex;
      align-items: center;

      ::v-deep .el-input {
        width: 100%;
      }

      ::v-deep .el-input__inner {
        background-color: white;
        text-align: left;
        border: none;
        padding-left: 0;
      }

    ::v-deep .el-textarea__inner {
        background-color: white;
        border: none;
        padding-left: 0;
    }

      ::v-deep .el-select {
        width: 100%;
  }

      ::v-deep .cargo-advance-select,
      ::v-deep .cargo-company-select,
      ::v-deep .cargo-packing-select {
    width: 100%;
      }
    }

    .item3-1 ::v-deep input.el-input__inner {
    background-color: white;
    }
  }
  .item4 {
    width: 100%;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    min-height: 100px;
    position: relative;
    padding: 16px;
    border: 2px solid #ddd;
    border-radius: 4px;
    background-color: #fff;

    .field-label {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 6px;
      color: #666;
    }

    .field-value {
      flex: 1;
      font-size: 14px;
      color: #333;
      min-height: 20px;

      // 让所有表单组件撑满容器宽度
      ::v-deep .el-select {
        width: 100% !important;
      }

      ::v-deep .el-input {
        width: 100% !important;
      }

      ::v-deep .el-input-number {
        width: 100% !important;
      }

      ::v-deep .el-textarea {
        width: 100% !important;
      }

      ::v-deep .cargo-advance-select {
        width: 100% !important;
      }

      ::v-deep .cargo-company-select {
        width: 100% !important;
      }

      ::v-deep .cargo-packing-select {
        width: 100% !important;
      }

      ::v-deep .cargo-user-select {
        width: 100% !important;
      }

      ::v-deep .cargo-office-select {
        width: 100% !important;
      }

      ::v-deep .cargo-department-select {
        width: 100% !important;
      }

      ::v-deep .auto-number-input {
        width: 100% !important;
      }

      ::v-deep .el-input__inner {
      background-color: white;
        text-align: left;
        border: 1px solid #ddd;
    }

    ::v-deep .el-textarea__inner {
      background-color: white;
        border: 1px solid #ddd;
      }

      // 为textarea字段设置固定高度，确保与左侧对称
      &.field-value-textarea {
        ::v-deep .el-textarea .el-textarea__inner {
          min-height: 144px !important;
          max-height: 144px !important;
          resize: none;
          line-height: 1.5;
          padding: 8px 12px;
          box-sizing: border-box;
        }
      }
    }
  }
  .color-yellow {
    ::v-deep textarea.el-textarea__inner {
      color: #e36402;
    }
  }
  .is-require {
    color: #4abff3;
  }
  .color-red {
    ::v-deep input::placeholder{
      color: red !important;
    }
  }
}
</style>
